import { IonButton, IonIcon, IonRouterLink } from '@ionic/react';
import React, { useCallback } from 'react';

import ButtonContainer from '@/components/common/buttonContainer/ButtonContainer';
import Spacer from '@/components/common/spacer/Spacer';
import Selection from '@/components/selection/Selection';
import { useScheduleFlow } from '@/contexts/ScheduleFlowContext';
import useToast from '@/hooks/useToast';
import { SCHEDULE_FLOW_STEPS } from '@/utils/constants';
import { arrowForwardCircleOutline } from 'ionicons/icons';
import moment from 'moment';

import './SelectTime.css';

const SelectTime: React.FC = () => {
  const {
    selectedDate,
    availableTimeslots,
    selectedTime,
    setSelectedTime,
    setCurrentStep
  } = useScheduleFlow();

  const displayToast = useToast();
  const copy = {
    subHeader: 'SELECT YOUR PREFERRED TIME',
    header: 'Choose a Time',
    buttonText: 'Next'
  };

  const onNext = () => {
    if (selectedTime) {
      setCurrentStep(SCHEDULE_FLOW_STEPS.SIGN_UP);
    } else {
      displayToast({
        message: 'Please select a time to proceed.',
        duration: 2400,
        position: 'bottom',
        positionAnchor: 'nextButton'
      });
    }
  };

  const onChangeDate = () => {
    setCurrentStep(SCHEDULE_FLOW_STEPS.SELECT_DATE);
  };

  const getLabel = (time: string) => {
    return moment(time, 'HH:mm').format('h:mm A');
  };

  const isSelected = (time: string) => {
    return time === selectedTime;
  };

  return (
    <div id="selectTime">
      <Spacer top={32} bottom={16}>
        <h4 id="subHeader">{copy.subHeader}</h4>
        <h1 id="header">{copy.header}</h1>
      </Spacer>
      <div id="date">
        <h2 id="selectedDate">
          {moment(selectedDate || new Date()).format('dddd, MMMM Do YYYY')}
        </h2>
        <IonRouterLink onClick={onChangeDate} id="changeDate">
          Change Date
        </IonRouterLink>
      </div>
      <Spacer top={16} bottom={102}>
        <Selection
          options={availableTimeslots}
          getLabel={getLabel}
          onClick={setSelectedTime}
          isSelected={isSelected}
        />
      </Spacer>
      <ButtonContainer>
        <IonButton
          id="nextButton"
          onClick={onNext}
          expand="block"
          fill="solid"
          size="default"
          strong={true}
        >
          <IonIcon slot="start" icon={arrowForwardCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
      </ButtonContainer>
    </div>
  );
};

export default SelectTime;
